import { Directive, EmbeddedViewRef, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { PartnerFeature } from '@shared/models';
import { SubSink } from 'subsink';
import { StayStore } from '../stay.store';

@Directive({
  selector: '[cwtHasPartnerFeature]'
})
export class HasPartnerFeatureDirective implements OnInit, OnChanges {
  private sub = new SubSink();

  @Input('cwtHasPartnerFeature') feature: PartnerFeature | null | undefined;
  @Input('cwtHasPartnerFeatureElse') elseTemplate: TemplateRef<any>;
  private _view: EmbeddedViewRef<any>;
  private _elseView: EmbeddedViewRef<any>;

  constructor(
    private templateRef: TemplateRef<any>,
    private vcRef: ViewContainerRef,
    private store: StayStore,
  ) { }

  ngOnInit(): void {
    this.sub.sink = this.store.state$.subscribe(() => this._updateTemplate());
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { feature, elseTemplate } = changes;
    if ((
      (feature && !feature.isFirstChange()) ||
      (elseTemplate && !elseTemplate.isFirstChange())
    )) this._updateTemplate();
  }

  private _updateTemplate() {
    const { activePartner } = this.store.getValue();
    if (!activePartner || (this.feature && !activePartner[this.feature])) {
      if (this._view || (this._elseView && !this.elseTemplate)) {
        this.vcRef.clear();
        this._view = null;
      }
      if (!this._elseView && this.elseTemplate) this._elseView = this.vcRef.createEmbeddedView(this.elseTemplate);
    } else {
      if (this._elseView) {
        this.vcRef.clear();
        this._elseView = null;
      }
      if (!this._view) this._view = this.vcRef.createEmbeddedView(this.templateRef);
    }

    this._elseView?.markForCheck();
    this._view?.markForCheck();
  }
}
